// app/javascript/controllers/answer_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [ "solution"]
    static values = {
        url: String,
        id: Number,
        wrongAnswerId: String
    }

    async submitSolution(event) {
        event.preventDefault()

        const csrfToken = document.querySelector("[name='csrf-token']").content

        let solution_letters = Array.from(document.querySelectorAll('.solution-letter'))
        let solution = ''

        if (solution_letters.length > 0) {
            solution_letters.forEach(function(el) {
                solution = solution + el.value
            });
        }

        try {
            const response = await fetch(this.urlValue, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-Token": csrfToken
                },
                body: JSON.stringify({
                    paper_id: this.idValue,
                    solution: solution
                })
            })

            if (!response.ok) {
                throw new Error("Serverantwort war nicht OK")
            }

            const data = await response.json()
            const passed = data.passed

            if (passed === 'nenene') {
                $(".wrong-answer").removeClass("d-none")
            } else {
                const paperButtonId = "button_" + this.idValue
                $("#" + paperButtonId).html('<div class="btn-circle-A">Gut gemacht</div>')
                $(".wrong-answer").addClass("d-none")

                if (passed === 'woah') {
                    $("#bananas_count").html(data.current_bananas)
                    $("#answer_bananas").html('3 Bananen')
                    $("#answer_type").html('zum <strong>Titelthema</strong>')
                    $("#collapseCorrectAnswer").show()
                    $("#collapseSuperAnswer").show()
                }
            }
        } catch (error) {
            console.error("Fehler beim Senden der Lösung:", error)
        }
    }



    async submitSolutionArticle(event) {
        event.preventDefault()
        const csrfToken = document.querySelector("[name='csrf-token']").content

        let solution_letters = Array.from(this.solutionTarget.querySelectorAll('.solution-letter'))
        let solution = ''

        if (solution_letters.length > 0) {
            solution_letters.forEach(function(el) {
                solution = solution + el.value
            });
        }



        try {
            const response = await fetch(this.urlValue, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-Token": csrfToken
                },
                body: JSON.stringify({
                    article_id: this.idValue,
                    solution: solution
                })
            })

            if (!response.ok) {
                throw new Error("Serverantwort war nicht OK")
            }

            const data = await response.json()
            const passed = data.passed

            const wrong_answer = "wrong_" + this.idValue
            console.log("sdfdsf")
            console.log(wrong_answer)
            if (passed === 'nenene') {
                $("#"+wrong_answer).removeClass("d-none")

            } else {
                const articleButtonId = "button_" + this.idValue

                $("#" + articleButtonId).html('<div class="btn-circle-A">Gut gemacht</div>')
                $("#"+wrong_answer).addClass("d-none")

                if (passed === 'woah') {
                    $("#answer_bananas").html(data.bananas)
                    $("#answer_type").html('zu den <strong>Kurzmeldungen</strong>')
                    $("#collapseCorrectAnswer").show()
                }
            }
        } catch (error) {
            console.error("Fehler beim Senden der Lösung:", error)
        }
    }


    async submitSolutionRiddle(event) {
        event.preventDefault()
        const csrfToken = document.querySelector("[name='csrf-token']").content

        let solution_letters = Array.from(this.solutionTarget.querySelectorAll('.solution-letter'))
        let solution = ''

        if (solution_letters.length > 0) {
            solution_letters.forEach(function(el) {
                solution = solution + el.value
            });
        }



        try {
            const response = await fetch(this.urlValue, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-Token": csrfToken
                },
                body: JSON.stringify({
                    riddle_id: this.idValue,
                    solution: solution
                })
            })

            if (!response.ok) {
                throw new Error("Serverantwort war nicht OK")
            }

            const data = await response.json()
            const passed = data.passed

            const wrong_answer = "wrong_" + this.idValue

            if (passed === 'nenene') {
                $("#"+wrong_answer).removeClass("d-none")

            } else {
                const riddleButtonId = "button_" + this.idValue

                $("#" + riddleButtonId).html('<div class="btn-circle-A">Gut gemacht</div>')
                $("#"+wrong_answer).addClass("d-none")
            }
        } catch (error) {
            console.error("Fehler beim Senden der Lösung:", error)
        }
    }


}
